import { css } from "styled-components"; // eslint-disable-line

export function minWidthMedia(minWidth: string) {
  return (...cssArgs: Parameters<typeof css>) => css`
    @media (min-width: ${minWidth}) {
      ${css(...cssArgs)};
    }
  `;
}
